import { type Ref, computed } from "vue";

import { useQuery } from "@tanstack/vue-query";

import { QUERY_KEYS } from "@/helpers/constants/queryKeys";
import clientsApiService from "@/services/modules/clients";

export const useWebhookSupportQuery = (clientId: Ref<string | undefined>) => {
  return useQuery({
    queryKey: computed(() =>
      QUERY_KEYS.WEBHOOK_SUPPORT.byClient(clientId.value!)
    ),
    queryFn: () =>
      clientsApiService.getWebhookSupportedServices(clientId.value!),
    staleTime: Infinity,
    enabled: computed(() => !!clientId.value),
  });
};
